export default __webpack_public_path__ + "static/media/external_link.64a9ad7e.svg";